export default "__VITE_ASSET__BwM2qFCQ__"